'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _colors = require('HubStyleTokens/colors');

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIBadge = require('UIComponents/badge/UIBadge');

var _UIBadge2 = _interopRequireDefault(_UIBadge);

var _H = require('UIComponents/elements/headings/H2');

var _H2 = _interopRequireDefault(_H);

var _ProductPageIcons = require('pricing-pages-unified-ui/constants/ProductPageIcons');

var _ProductPageIcons2 = _interopRequireDefault(_ProductPageIcons);

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _HighlightedMerchHeaderConfig = require('pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig');

var _HighlightedMerchHeaderConfig2 = _interopRequireDefault(_HighlightedMerchHeaderConfig);

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopHeaderCell = _styledComponents2.default.th.withConfig({
  displayName: 'GrowthSuiteCatalogEditionHeader__TopHeaderCell'
})(['padding:12px 20px;background-color:', ';border-top:1px solid ', ';border-bottom:1px solid ', ';height:50px;text-align:center;width:18.75%;min-width:175px;font-weight:500;& > h6{margin:0;}:first-child{width:25%;text-align:left;}h2{font-size:20px;}.growth-suite-bold{font-weight:600;}'], _colors.OLAF, _colors.GREAT_WHITE, _colors.GREAT_WHITE);

var Table = _styledComponents2.default.table.withConfig({
  displayName: 'GrowthSuiteCatalogEditionHeader__Table'
})(['border-spacing:0;width:100%;margin-bottom:0;']);

var GrowthSuiteCatalogEditionHeader = function GrowthSuiteCatalogEditionHeader(_ref) {
  var currencyCode = _ref.currencyCode,
      edition = _ref.edition,
      products = _ref.products,
      hub = _ref.hub,
      isHSFXEligible = _ref.isHSFXEligible;

  var merchIdForHubEdition = _SuiteEditionMerchIdMap2.default[edition][hub];
  var headerConfig = _HighlightedMerchHeaderConfig2.default[merchIdForHubEdition];
  var includes = headerConfig.includes;


  var standalonePrice = products[merchIdForHubEdition].prices.find(function (price) {
    return price.currencyCode === currencyCode;
  }).value;

  return _react2.default.createElement(
    Table,
    null,
    _react2.default.createElement(
      'thead',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          TopHeaderCell,
          null,
          _react2.default.createElement(
            'div',
            { style: { float: 'left' } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_UIImage2.default, {
                className: 'display-inline m-right-2 m-bottom-2',
                width: 15,
                src: _ProductPageIcons2.default[hub]
              }),
              _react2.default.createElement(
                _H2.default,
                { className: 'display-inline' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                  message: 'pricingPage.pages.growthSuite.catalogModal.' + hub + '.' + edition
                })
              )
            ),
            _react2.default.createElement(
              _Small2.default,
              {
                use: 'help',
                className: 'm-left-6',
                style: { fontWeight: 400 }
              },
              _react2.default.createElement(_FormattedMessage2.default, { message: includes })
            )
          ),
          !isHSFXEligible && _react2.default.createElement(
            'div',
            { style: { float: 'right' } },
            _react2.default.createElement(
              'div',
              {
                style: { textAlign: 'right', height: '27.19px' },
                className: 'p-top-1'
              },
              _react2.default.createElement(
                _UIBadge2.default,
                { use: 'new' },
                _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.percentDiscountBadge' })
              )
            ),
            _react2.default.createElement(
              _Small2.default,
              { use: 'help', style: { fontWeight: 400 } },
              _react2.default.createElement(_FormattedJSXMessage2.default, {
                message: 'pricingPage.pages.growthSuite.standalonePrice_jsx',
                options: {
                  currencyCode: currencyCode,
                  price: standalonePrice
                },
                elements: {
                  Price: _PriceDisplay2.default
                }
              })
            )
          )
        )
      )
    )
  );
};

function mapStateToProps(state) {
  return {
    isHSFXEligible: (0, _PromotionSelectors.isHSFXEligibleSelector)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteCatalogEditionHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-catalog/GrowthSuiteCatalogEditionHeader.js
// module id = 777
// module chunks = 3 4